import { HERMES_BASE_URL } from "./hermes-singleton.js";

/** Turn gateway report paths into browser-loadable URLs. */
export function resolveExecutionReportUrl(raw: string, executionId?: string): string {
  const url = String(raw || "").trim();
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || url.startsWith("data:") || url.startsWith("blob:")) {
    return url;
  }
  const base = HERMES_BASE_URL.replace(/\/+$/, "");
  if (url.startsWith("/")) {
    return base ? `${base}${url}` : url;
  }
  const id = String(executionId || "").trim();
  if (id) {
    if (url.includes("/reports/")) {
      const marker = `/executions/${id}/reports/`;
      const idx = url.indexOf(marker);
      if (idx >= 0) {
        const path = url.slice(idx - "/v1/projects".length);
        return base ? `${base}${path.startsWith("/") ? path : `/${path}`}` : `/${path}`;
      }
    }
    if (!url.includes("/")) {
      return `${base}/v1/projects/executions/${id}/reports/${url}`;
    }
  }
  return url;
}
